import { kebabCase } from "lodash-es";

export const DASHBOARD_BASE_PATH = "/dashboard";

export const AI_INSIGHTS_FEED_SLUG = "ai-insights-feed";
export const AI_INSIGHTS_FEED_PATH = `${DASHBOARD_BASE_PATH}/${AI_INSIGHTS_FEED_SLUG}`;

export interface DashboardUrlTarget {
  global_id: string;
  name: string;
}

export const getDashboardUrlId = ({
  global_id,
}: Pick<DashboardUrlTarget, "global_id">): string => global_id;

export const getDashboardNameSlug = (name: string): string => kebabCase(name);

export const buildDashboardPath = (dashboard: DashboardUrlTarget): string => {
  const urlId = getDashboardUrlId(dashboard);
  const nameSlug = getDashboardNameSlug(dashboard.name);
  return nameSlug
    ? `${DASHBOARD_BASE_PATH}/${urlId}/${nameSlug}`
    : `${DASHBOARD_BASE_PATH}/${urlId}`;
};

export const buildDashboardNamePath = (name: string): string =>
  `${DASHBOARD_BASE_PATH}/${getDashboardNameSlug(name)}`;

export const isCanonicalDashboardNameSegment = (
  dashboard: DashboardUrlTarget,
  nameSegment: string | undefined
): boolean => (nameSegment ?? "") === getDashboardNameSlug(dashboard.name);
